import React, { Component } from "react";
import { Modal, Row, Col, Card, Form, Button, Table, Badge } from "react-bootstrap";
import { Formik, Field, ErrorMessage } from "formik";
import { AsyncTypeahead } from 'react-bootstrap-typeahead';
import { commonServices } from '../../commonServices/commonServices';
import { formatProperCase } from '../../../_metronic/utils/utils';
import * as constants from '../../constants';
import { ServiceRequestsServices } from '../../pages/home/ServiceRequests/ServiceRequests.services';
import { store } from 'react-notifications-component';
import * as firebase from 'firebase/app';
import "./estimation.css";



/**
 * GST %
 */
const GST_PERCENTAGE = 18;

/**
 * Estimate Types
 */
const ESTIMATE_TYPES = {
    FULL_COST:
        "FULL_COST",

    ITEM_WISE:
        "ITEM_WISE"
};

/**
 * Payment Types
 */
const PAYMENT_TYPES = {

    FULL_PAYMENT:
        "FULL_PAYMENT",

    ADVANCE_PAYMENT:
        "ADVANCE_PAYMENT"
};

/**
 * Vendor GST Registration
 */
const VENDOR_GST_REGISTRATION_TYPE = {

    GST_REGISTERED: "GST_REGISTERED",
    NON_GST_VENDOR: "NON_GST_VENDOR"
};

/*
Service Provider Type
*/

const SERVICE_PROVIDER_TYPE = {
    AZURO: "AZURO",
    VENDOR_WITH_AZURO_MARGIN: "VENDOR_WITH_AZURO_MARGIN",
    VENDOR_ONLY: "VENDOR_ONLY"
};

class EstimateModal extends Component {

    constructor(props) {

        super(props);

        this.state = {
            isLoading: false,
            options: [],
            query: '',
            offset: 0,
            limit: 50,
            serviceType: SERVICE_PROVIDER_TYPE.AZURO,
            gstType: VENDOR_GST_REGISTRATION_TYPE.GST_REGISTERED,
            formKey: 0
        };

        this.initialValues = {

            // =================================
            // Vendor
            // =================================

            vendorName: "",

            sendEstimateTo: "",

            // =================================
            // Customer
            // =================================

            customerName: "",

            address: "",

            gstin: "",

            // =================================
            // Service
            // =================================

            serviceName: "",

            // =================================
            // Estimate Config
            // =================================

            paymentType:
                PAYMENT_TYPES.FULL_PAYMENT,

            // =================================
            // Advance Payment
            // =================================

            advanceAmount: "",

            // =================================
            // Item Wise
            // =================================

            items: [
                {
                    itemName: "",

                    qty: 1,

                    amount: "",

                    margin: "",

                    gstPercentage: 18
                }
            ]
        };
    };

    cache = {};

    componentDidUpdate(prevProps) {
        if (!prevProps.show && this.props.show) {
            this.resetModalState();
        }
    }

    resetModalState = (resetForm) => {
        this.setState(prevState => ({
            serviceType: SERVICE_PROVIDER_TYPE.AZURO,
            gstType: VENDOR_GST_REGISTRATION_TYPE.GST_REGISTERED,
            options: [],
            query: '',
            formKey: prevState.formKey + 1
        }));
        if (resetForm) {
            resetForm();
        }
    };

    handleServiceTypeChange = (serviceType, resetForm) => {
        if (this.state.serviceType !== serviceType) {
            this.setState({
                serviceType,
                gstType: VENDOR_GST_REGISTRATION_TYPE.GST_REGISTERED,
                options: [],
                query: ''
            });
            if (resetForm) {
                resetForm();
            }
        }
    };

    handleInputChange = query => {
        this.setState({ query });
    };

    handlePagination = async (e, shownResults) => {
        const { query } = this.state;
        const cachedQuery = this.cache[query];
        if (
            cachedQuery.options.length > shownResults ||
            cachedQuery.options.length === cachedQuery.total_count
        ) {
            return;
        }
        this.setState({ isLoading: true });
        const page = cachedQuery.page + 1;
        const { limit } = this.state;
        const offset = (limit * (page - 1));
        await this.setState({ page, offset });
        const response = await this.getAllVendors();
        const options = cachedQuery.options.concat(response.options);
        this.cache[query] = { ...cachedQuery, options, page, offset };
        this.setState({ isLoading: false, options });
    };

    handleSearch = async (query) => {
        if (this.cache[query]) {
            this.setState({ options: this.cache[query].options });
            return;
        }
        this.setState({ isLoading: true });
        const response = await this.getAllVendors();
        this.cache[query] = { ...response, page: 1 };
        this.setState({
            isLoading: false,
            options: response && response.options,
        });
    };

    getAllVendors = async () => {
        this.setState({ isLoading: true });
        const { offset, limit, query } = this.state;
        const data = {
            searchQuery: query,
            isVendor: 'TRUE',
            offset,
            limit
        };
        const result = await commonServices.getUserListData(data);
        if (result && result.status === 200) {
            const total_count = result.headers['x-total-count'];
            const options = result.data.users.map(userData => ({
                id: userData.id,
                vendor: userData.fullName,
            }));
            return { options, total_count };
        }
        this.setState({ isLoading: false });
    };

    // ===================================================
    // Currency Formatter
    // ===================================================

    formatCurrency = amount => {

        return Number(
            amount || 0
        ).toLocaleString(
            "en-IN",
            {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
            }
        );
    };

    // ===================================================
    // Add Item Row
    // ===================================================

    addItem = (
        values,
        setFieldValue
    ) => {

        const items = [
            ...values.items
        ];

        items.push({

            itemName: "",

            qty: 1,

            amount: "",

            margin: "",

            gstPercentage: 18
        });

        setFieldValue(
            "items",
            items
        );
    };

    // ===================================================
    // Remove Item Row
    // ===================================================

    removeItem = (
        index,
        values,
        setFieldValue
    ) => {

        if (
            values.items.length === 1
        ) {
            return;
        }

        const items = [
            ...values.items
        ];

        items.splice(
            index,
            1
        );

        setFieldValue(
            "items",
            items
        );
    };

    // ===================================================
    // Validation
    // ===================================================

    validate = values => {

        const errors = {};

        if (
            !values.vendorName
        ) {
            errors.vendorName =
                "Vendor name is required";
        }

        if (
            !values.customerName
        ) {
            errors.customerName =
                "Customer name is required";
        } else if (
            !/^[a-zA-Z\s]+$/.test(values.customerName)
        ) {
            errors.customerName =
                "Only alphabets are allowed";
        }

        if (
            !values.address || !values.address.trim()
        ) {
            errors.address =
                "Address is required";
        }

        if (
            !values.serviceName
        ) {
            errors.serviceName =
                "Service name is required";
        }

        if (
            values.gstin && values.gstin.trim() !== ""
        ) {
            const gstinRegex = /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/;
            if (!gstinRegex.test(values.gstin.trim())) {
                errors.gstin = "Invalid GSTIN format";
            }
        }

        // ==========================
        // Items Validation
        // ==========================

        if (!values.items || values.items.length === 0) {
            errors.items = "At least one item is required";
        } else {
            const itemErrors = [];
            let hasItemErrors = false;

            values.items.forEach((item, index) => {
                const itemError = {};

                if (!item.itemName || item.itemName.trim() === '') {
                    itemError.itemName = "Required";
                    hasItemErrors = true;
                }

                if (!item.qty || Number(item.qty) <= 0) {
                    itemError.qty = ">0";
                    hasItemErrors = true;
                }

                if (item.amount === undefined || item.amount === '' || Number(item.amount) < 0) {
                    itemError.amount = "Invalid";
                    hasItemErrors = true;
                }

                if (this.state.serviceType !== SERVICE_PROVIDER_TYPE.VENDOR_ONLY && (item.margin === undefined || item.margin === '' || Number(item.margin) < 0)) {
                    itemError.margin = "Invalid";
                    hasItemErrors = true;
                }

                itemErrors[index] = itemError;
            });

            if (hasItemErrors) {
                errors.items = itemErrors;
            }
        }

        // ==========================
        // Advance Validation
        // ==========================

        if (
            values.paymentType ===
            PAYMENT_TYPES.ADVANCE_PAYMENT
        ) {

            const summary =
                this.calculateEstimate(
                    values
                );

            const advance =
                Number(
                    values.advanceAmount || 0
                );

            if (
                advance <= 0
            ) {
                errors.advanceAmount =
                    "Advance amount must be greater than zero";
            }
            else if (
                advance >
                summary.customerPays
            ) {

                errors.advanceAmount =
                    "Advance amount cannot exceed customer payable amount";
            }
        }

        return errors;
    };

    // ===================================================
    // Main Calculation Engine
    // ===================================================

    test_calculateEstimate = values => {

        let vendorCost = 0;

        let margin = 0;

        // ==========================================
        // FULL COST
        // ==========================================

        if (
            values.estimateType ===
            ESTIMATE_TYPES.FULL_COST
        ) {

            vendorCost =
                Number(
                    values.vendorCost || 0
                );

            margin =
                Number(
                    values.orgMargin || 0
                );
        }

        // ==========================================
        // ITEM WISE COST
        // ==========================================

        else {

            values.items.forEach(
                item => {

                    vendorCost +=
                        Number(
                            item.amount || 0
                        );

                    margin +=
                        Number(
                            item.margin || 0
                        );
                }
            );
        }

        // ==========================================
        // Customer Pays
        // ==========================================

        const customerPays =
            vendorCost +
            margin;

        /**
         * GST Extraction
         *
         * GST Inclusive Amount
         *
         * Formula:
         *
         * Amount × 18 / 118
         */

        const gstInBill =
            customerPays *
            GST_PERCENTAGE /
            (
                100 +
                GST_PERCENTAGE
            );

        const inputGstCredit =
            this.state.gstType === VENDOR_GST_REGISTRATION_TYPE.NON_GST_VENDOR
                ? 0
                : vendorCost * GST_PERCENTAGE / (100 + GST_PERCENTAGE);

        const netGst =
            gstInBill -
            inputGstCredit;

        /**
         * Net Earnings
         *
         * Margin - GST
         */

        const orgEarning =
            margin -
            netGst;

        return {

            vendorCost,

            margin,

            customerPays,

            gstInBill,

            inputGstCredit,

            netGst,

            orgEarning
        };
    };


    //calculateGST = (amount, gstPercentage) => {

    //    const gst = Number(gstPercentage || 0);

    //    return (
    //        Number(amount || 0) *
    //        gst /
    //        (100 + gst)
    //    );
    //};


    calculateGST = (amount, gstPercentage, isInclusive = true) => {

        const amt = Number(amount || 0);
        const gst = Number(gstPercentage || 0);

        let gstAmount = 0;
        let baseAmount = 0;
        let totalAmount = 0;

        if (isInclusive) {

            // Amount already includes GST
            gstAmount = (amt * gst) / (100 + gst);
            baseAmount = amt - gstAmount;
            totalAmount = amt;

        } else {

            // GST needs to be added separately
            gstAmount = (amt * gst) / 100;
            baseAmount = amt;
            totalAmount = amt + gstAmount;
        }

        return {
            baseAmount: Number(baseAmount.toFixed(2)),
            gstAmount: Number(gstAmount.toFixed(2)),
            totalAmount: Number(totalAmount.toFixed(2))
        };
    };




    // ===================================================
    // Main Calculation Engine
    // ===================================================

    // ===================================================
    // Per-item GST-exclusive calculation
    // Customer Cost = Qty * (BaseCost + Markup) + Qty * (BaseCost + Markup) * GST%
    // Tax Amount    = Qty * (BaseCost + Markup) * GST%
    // ===================================================

    calculateItemRow = (item) => {
        const qty = Number(item.qty || 1);
        const baseCost = Number(item.amount || 0);
        const markup = Number(item.margin || 0);
        const gstPct = Number(item.gstPercentage || 0);

        const subtotal = qty * (baseCost + markup);
        const taxAmount = subtotal * gstPct / 100;
        const customerTotal = subtotal + taxAmount;

        return { qty, baseCost, markup, gstPct, subtotal, taxAmount, customerTotal };
    };

    calculateEstimate = values => {

        let vendorCost = 0;

        let margin = 0;

        let gstInBill = 0;

        let inputGstCredit = 0;

        const isNonGstVendor =
            this.state.gstType ===
            VENDOR_GST_REGISTRATION_TYPE.NON_GST_VENDOR;

        // ==========================================
        // ITEM WISE (only mode)
        // ==========================================

        let totalCustomerPays = 0;

        (values.items || []).forEach(item => {

            const { qty, baseCost, markup, taxAmount, customerTotal } =
                this.calculateItemRow(item);

            vendorCost += qty * baseCost;
            margin += qty * markup;
            gstInBill += taxAmount;
            totalCustomerPays += customerTotal;

            switch (this.state.serviceType) {
                case SERVICE_PROVIDER_TYPE.AZURO:
                    inputGstCredit += 0;
                    break;
                case SERVICE_PROVIDER_TYPE.VENDOR_WITH_AZURO_MARGIN:
                    if (!isNonGstVendor) {
                        inputGstCredit += qty * baseCost * Number(item.gstPercentage || 0) / 100;
                    }
                    break;
                case SERVICE_PROVIDER_TYPE.VENDOR_ONLY:
                    if (!isNonGstVendor) {
                        inputGstCredit += qty * baseCost * Number(item.gstPercentage || 0) / 100;
                    }
                    break;
                default:
                    break;
            }
        });

        // ==========================================
        // FINAL CALCULATIONS
        // ==========================================

        const netGst = gstInBill - inputGstCredit;

        let orgEarning = 0;
        switch (this.state.serviceType) {
            case SERVICE_PROVIDER_TYPE.AZURO:
                orgEarning = margin;
                break;
            case SERVICE_PROVIDER_TYPE.VENDOR_WITH_AZURO_MARGIN:
                orgEarning = margin;
                break;
            case SERVICE_PROVIDER_TYPE.VENDOR_ONLY:
                orgEarning = 0;
                break;
            default:
                break;
        }

        return {
            vendorCost,
            margin,
            customerPays: totalCustomerPays,
            gstInBill,
            inputGstCredit,
            netGst,
            orgEarning
        };
    };



    // ===================================================
    // Payment Summary
    // ===================================================

    getPaymentSummary = (
        values,
        customerPays
    ) => {

        if (
            values.paymentType ===
            PAYMENT_TYPES.FULL_PAYMENT
        ) {

            return {

                payNow:
                    customerPays,

                balanceDue: 0
            };
        }

        const advance =
            Number(
                values.advanceAmount || 0
            );

        const safeAdvance =
            Math.min(
                advance,
                customerPays
            );

        return {

            payNow:
                safeAdvance,

            balanceDue:
                customerPays -
                safeAdvance
        };
    };

    handleSubmit = async (values, { setSubmitting }) => {
        try {
            const serviceRequestId = this.props.serviceRequestId ? parseInt(this.props.serviceRequestId, 10) : undefined;
            const approverId = values.sendEstimateTo ? parseInt(values.sendEstimateTo, 10) : undefined;
            const advancePaymentAmount = values.paymentType === PAYMENT_TYPES.ADVANCE_PAYMENT ? Number(values.advanceAmount || 0) : 0;
            const raiserId = values.vendorId ? parseInt(values.vendorId, 10) : undefined;
            const serviceType = this.state.serviceType;
            const gstType = this.state.gstType;

            let costEstimateItems = [];
            if (values.estimateType === ESTIMATE_TYPES.FULL_COST) {
                const amount = Number(values.vendorCost || 0);
                const margin = Number(values.orgMargin || 0);
                costEstimateItems.push({
                    name: values.serviceName || "Service Cost",
                    amount: amount,
                    qty: 1,
                    margin: margin,
                    gstPercentage: 18
                });
            } else {
                costEstimateItems = (values.items || []).map((item) => {
                    const amount = Number(item.amount || 0);
                    const margin = Number(item.margin || 0);
                    return {
                        name: item.itemName || values.serviceName || "Service Item",
                        amount: amount,
                        qty: Number(item.qty || 1),
                        margin: margin,
                        gstPercentage: Number(item.gstPercentage || 18)
                    };
                });
            }

            const data = {
                approverId,
                serviceRequestId,
                advancePaymentAmount,
                costEstimateItems,
                raiserId,
                serviceType,
                gstType,
                customerName: values.customerName || null,
                address: values.address || null,
                gstin: values.gstin || null,
                serviceName: values.serviceName || null,
                paymentType: values.paymentType || null
            };

            const result = await ServiceRequestsServices.addEstimates(data);
            if (result && result.status === 201) {
                store.addNotification({
                    title: "Success!",
                    message: `Estimate created!`,
                    type: "success",
                    insert: "top",
                    container: "top-right",
                    animationIn: ["animated", "fadeIn"],
                    animationOut: ["animated", "fadeOut"],
                    dismiss: {
                        duration: 5000,
                        onScreen: true,
                        showIcon: true,
                        pauseOnHover: true
                    }
                });

                if (this.props.onHide) {
                    this.props.onHide();
                }

                if (serviceRequestId && this.props.parentCallback) {
                    try {
                        firebase.analytics().logEvent("add_estimate_button_click", {
                            description: "Add Estimate Button Clicked",
                            addEstimateFrom: "Service Requests"
                        });
                    } catch (e) {
                        console.error(e);
                    }
                    this.props.parentCallback(serviceRequestId);
                }
            } else {
                throw new Error("Unable to save estimate.");
            }
        } catch (error) {
            console.error("Error creating cost estimate: ", error);
            store.addNotification({
                title: "Error!",
                message: error?.response?.data?.message || "Failed to create cost estimate. Please try again.",
                type: "danger",
                insert: "top",
                container: "top-right",
                animationIn: ["animated", "fadeIn"],
                animationOut: ["animated", "fadeOut"],
                dismiss: {
                    duration: 5000,
                    onScreen: true,
                    showIcon: true,
                    pauseOnHover: true
                }
            });
        } finally {
            if (setSubmitting) {
                setSubmitting(false);
            }
        }
    };
    // ===================================================
    // Right Side Financial Dashboard
    // ===================================================

    renderSummaryPanel = (
        summary,
        paymentSummary,
        values
    ) => {

        const exGstBase = summary.vendorCost + summary.margin;

        return (
            <div
                style={{
                    position: "sticky",
                    top: "10px"
                }}
            >
                {/* Cost Summary Card */}
                <Card className="mb-3 shadow-sm border-0" style={{ borderRadius: "12px", border: "1px solid #e2e8f0 !important", boxShadow: "0 1px 3px rgba(0,0,0,0.05)" }}>
                    <Card.Header className="bg-white border-bottom-0 pt-3 pb-0 d-flex justify-content-between align-items-center">
                        <strong style={{ fontSize: "15px", color: "#1e293b" }}>Cost Summary</strong>
                        <i className="far fa-file-alt text-muted" style={{ color: "#cbd5e1" }}></i>
                    </Card.Header>
                    <Card.Body className="pt-3 pb-3">
                        <div className="d-flex justify-content-between mb-2">
                            <span style={{ fontSize: "13px", color: "#64748b" }}>Vendor Base Cost</span>
                            <span style={{ fontWeight: 600, fontSize: "13px", color: "#334155" }}>₹ {this.formatCurrency(summary.vendorCost)}</span>
                        </div>
                        <div className="d-flex justify-content-between mb-3">
                            <span style={{ fontSize: "13px", color: "#64748b" }}>Azuro Mark-up</span>
                            <span style={{ fontWeight: 600, fontSize: "13px", color: "#334155" }}>₹ {this.formatCurrency(summary.margin)}</span>
                        </div>

                        <div className="mb-3" style={{ borderBottom: '1px dashed #cbd5e1' }}></div>

                        <div className="d-flex justify-content-between mb-2">
                            <span style={{ fontSize: "12px", color: "#94a3b8" }}>Ex-GST base</span>
                            <span style={{ fontSize: "12px", color: "#94a3b8" }}>₹ {this.formatCurrency(exGstBase)}</span>
                        </div>
                        <div className="d-flex justify-content-between mb-3">
                            <span style={{ fontSize: "12px", color: "#94a3b8" }}>Total GST</span>
                            <span style={{ fontSize: "12px", color: "#94a3b8" }}>₹ {this.formatCurrency(summary.gstInBill)}</span>
                        </div>

                        <div className="mb-3 border-bottom" style={{ borderColor: '#e2e8f0' }}></div>

                        <div className="d-flex justify-content-between align-items-center">
                            <strong style={{ fontSize: "15px", color: "#1e293b" }}>Customer Total</strong>
                            <strong style={{ fontSize: "16px", color: "#2563eb" }}>₹ {this.formatCurrency(summary.customerPays)}</strong>
                        </div>
                    </Card.Body>
                </Card>

                {/* GST Details Card */}
                <Card className="mb-3 shadow-sm border-0" style={{ borderRadius: "12px", border: "1px solid #e2e8f0 !important", boxShadow: "0 1px 3px rgba(0,0,0,0.05)" }}>
                    <Card.Header className="bg-white border-bottom-0 pt-3 pb-0">
                        <strong style={{ fontSize: "15px", color: "#1e293b" }}>GST Details</strong>
                    </Card.Header>
                    <Card.Body className="pt-3 pb-3">

                        <div className="d-flex justify-content-between mb-3">
                            <span style={{ fontSize: "13px", color: "#64748b" }}>(Vendor GST) Input Credit</span>
                            <span style={{ fontWeight: 600, fontSize: "13px", color: "#16a34a" }}>- ₹ {this.formatCurrency(summary.inputGstCredit)}</span>
                        </div>

                        <div className="d-flex justify-content-between mb-2">
                            <span style={{ fontSize: "13px", color: "#64748b" }}>(Azuro GST) Output GST</span>
                            <span style={{ fontWeight: 600, fontSize: "13px", color: "#334155" }}>₹ {this.formatCurrency(summary.gstInBill)}</span>
                        </div>


                        <div className="mb-3 border-bottom" style={{ borderColor: '#e2e8f0' }}></div>

                        <div className="d-flex justify-content-between align-items-center mb-2">
                            <span style={{ fontSize: "14px", fontWeight: 600, color: "#1e293b" }}>Net GST to Govt</span>
                            <strong style={{ fontSize: "15px", color: "#ea580c" }}>₹ {this.formatCurrency(summary.netGst)}</strong>
                        </div>
                        <div style={{ fontSize: "11px", color: "#94a3b8", lineHeight: "1.4" }}>
                            Net GST liability to government after Input Tax Credit.
                        </div>
                    </Card.Body>
                </Card>

                {/* ORG NET EARNINGS Card */}
                <Card className="mb-3 shadow-sm border-0" style={{ borderRadius: "12px", border: "1px solid #fecaca !important", background: "#fef2f2", boxShadow: "0 1px 3px rgba(0,0,0,0.05)" }}>
                    <Card.Body className="py-3">
                        <div style={{ fontSize: "12px", fontWeight: 700, color: "#991b1b", letterSpacing: "0.5px", marginBottom: "4px" }}>
                            AZURO NET EARNINGS
                        </div>
                        <div style={{ color: "#dc2626", fontWeight: 700, fontSize: "20px", marginBottom: "4px" }}>
                            ₹ {this.formatCurrency(summary.orgEarning)}
                        </div>
                        <div style={{ fontSize: "11px", color: "#991b1b" }}>
                            After vendor payment + GST settlement
                        </div>
                        {summary.margin <= 0 && (
                            <div style={{ fontSize: "11px", color: "#b91c1c", marginTop: "6px", fontWeight: 600 }}>
                                <i className="fa fa-exclamation-triangle mr-1"></i> Margin cannot be zero or negative
                            </div>
                        )}
                    </Card.Body>
                </Card>

                {/* Payment Summary Card */}
                <Card className="shadow-sm border-0" style={{ borderRadius: "12px", border: "1px solid #e2e8f0 !important", boxShadow: "0 1px 3px rgba(0,0,0,0.05)" }}>
                    <Card.Header className="bg-white border-bottom-0 pt-3 pb-0">
                        <strong style={{ fontSize: "15px", color: "#1e293b" }}>Payment Summary</strong>
                    </Card.Header>
                    <Card.Body className="pt-3 pb-3">
                        <div className="d-flex justify-content-between align-items-center">
                            <div className="d-flex align-items-center">
                                <div style={{ width: "8px", height: "8px", borderRadius: "50%", background: "#10b981", marginRight: "8px" }}></div>
                                <span style={{ fontSize: "13px", color: "#334155" }}>
                                    {values.paymentType === PAYMENT_TYPES.FULL_PAYMENT ? "Full Payment Due" : "Advance Payment Due"}
                                </span>
                            </div>
                            <strong style={{ fontSize: "15px", color: "#10b981" }}>
                                ₹ {this.formatCurrency(paymentSummary.payNow)}
                            </strong>
                        </div>
                        {values.paymentType === PAYMENT_TYPES.ADVANCE_PAYMENT && (
                            <div className="d-flex justify-content-between align-items-center mt-2">
                                <div className="d-flex align-items-center">
                                    <div style={{ width: "8px", height: "8px", borderRadius: "50%", background: "#eab308", marginRight: "8px" }}></div>
                                    <span style={{ fontSize: "13px", color: "#334155" }}>
                                        Balance Due
                                    </span>
                                </div>
                                <strong style={{ fontSize: "15px", color: "#eab308" }}>
                                    ₹ {this.formatCurrency(paymentSummary.balanceDue)}
                                </strong>
                            </div>
                        )}
                    </Card.Body>
                </Card>
            </div>
        );
    };

    // ===================================================
    // Render
    // ===================================================

    render() {

        const {
            show,
            onHide
        } = this.props;

        return (

            <Modal

                show={show}

                onHide={onHide}

                size="xl"

                backdrop="static"

                centered

                dialogClassName="modal-widescreen"

            >
                <Formik
                    key={this.state.formKey}
                    initialValues={
                        this.initialValues
                    }
                    validate={
                        this.validate
                    }
                    onSubmit={
                        this.handleSubmit
                    }>

                    {({

                        values,

                        setFieldValue,

                        resetForm,

                        handleSubmit,

                        isSubmitting

                    }) => {

                        const summary =
                            this.calculateEstimate(
                                values
                            );

                        const paymentSummary =
                            this.getPaymentSummary(
                                values,
                                summary.customerPays
                            );
                        return (

                            <React.Fragment>

                                {/* ===================================== */}
                                {/* HEADER */}
                                {/* ===================================== */}

                                <Modal.Header closeButton style={{ background: "#fff", borderBottom: "1px solid #e2e8f0", padding: "16px 24px" }}>
                                    <Modal.Title style={{ fontWeight: 700, fontSize: "18px", color: "#1e293b" }}>
                                        <i className="far fa-file-alt mr-2" style={{ color: "#2563eb", fontSize: "18px" }}></i>
                                        Add Estimate
                                    </Modal.Title>
                                </Modal.Header>

                                {/* ===================================== */}
                                {/* BODY */}
                                {/* ===================================== */}

                                <Modal.Body style={{ background: "#f8fafc", padding: "20px 24px" }}>

                                    <h5>Service Provider Type</h5>

                                    {/* OPTION 1 */}
                                    <label
                                        style={{
                                            display: "block",
                                            border: this.state.serviceType ===
                                                SERVICE_PROVIDER_TYPE.AZURO ? "2px solid #0d6efd" : "1px solid #ddd",
                                            padding: "15px",
                                            borderRadius: "10px",
                                            marginBottom: "10px",
                                            cursor: "pointer",
                                            background: this.state.serviceType ===
                                                SERVICE_PROVIDER_TYPE.AZURO ? "#f0f6ff" : "#fff"
                                        }}
                                    >
                                        <input
                                            type="radio"
                                            name="serviceType"
                                            selected="true"
                                            value="azuro"
                                            checked={this.state.serviceType ===
                                                SERVICE_PROVIDER_TYPE.AZURO}
                                            onChange={() => this.handleServiceTypeChange(
                                                SERVICE_PROVIDER_TYPE.AZURO,
                                                resetForm
                                            )}
                                            style={{ marginRight: "10px" }}
                                        />

                                        <strong>Azuro Property Management Services</strong>
                                        <div style={{ fontSize: "12px", color: "#666" }}>
                                            Azuro MST Service
                                        </div>
                                    </label>

                                    {/* OPTION 2 */}
                                    <label
                                        style={{
                                            display: "block",
                                            border: this.state.serviceType === SERVICE_PROVIDER_TYPE.VENDOR_WITH_AZURO_MARGIN ? "2px solid #0d6efd" : "1px solid #ddd",
                                            padding: "15px",
                                            borderRadius: "10px",
                                            marginBottom: "10px",
                                            cursor: "pointer",
                                            background: this.state.serviceType === SERVICE_PROVIDER_TYPE.VENDOR_WITH_AZURO_MARGIN ? "#f0f6ff" : "#fff"
                                        }}
                                    >
                                        <input
                                            type="radio"
                                            name="serviceType"
                                            value="vendor_margin"
                                            checked={this.state.serviceType === SERVICE_PROVIDER_TYPE.VENDOR_WITH_AZURO_MARGIN}
                                            onChange={() => this.handleServiceTypeChange(SERVICE_PROVIDER_TYPE.VENDOR_WITH_AZURO_MARGIN, resetForm)}
                                            style={{ marginRight: "10px" }}
                                        />

                                        <strong>Subcontractor</strong>
                                        <div style={{ fontSize: "12px", color: "#666" }}>
                                            Onboarded Azuro Vendors. Azuro Invoice Provided.
                                        </div>
                                    </label>

                                    {/* OPTION 3 */}
                                    <label
                                        style={{
                                            display: "block",
                                            border: this.state.serviceType === SERVICE_PROVIDER_TYPE.VENDOR_ONLY ? "2px solid #0d6efd" : "1px solid #ddd",
                                            padding: "15px",
                                            borderRadius: "10px",
                                            cursor: "pointer",
                                            background: this.state.serviceType === SERVICE_PROVIDER_TYPE.VENDOR_ONLY ? "#f0f6ff" : "#fff"
                                        }}
                                    >
                                        <input
                                            type="radio"
                                            name="serviceType"
                                            value="vendor_only"
                                            checked={this.state.serviceType === SERVICE_PROVIDER_TYPE.VENDOR_ONLY}
                                            onChange={() => this.handleServiceTypeChange(SERVICE_PROVIDER_TYPE.VENDOR_ONLY, resetForm)}
                                            style={{ marginRight: "10px" }}
                                        />

                                        <strong>External Vendor</strong>
                                        <div style={{ fontSize: "12px", color: "#666" }}>
                                            Tenant or Owner is Billed
                                        </div>
                                    </label>


                                    {/* Vendor GST Registration */}
                                    {(this.state.serviceType === SERVICE_PROVIDER_TYPE.VENDOR_WITH_AZURO_MARGIN || this.state.serviceType === SERVICE_PROVIDER_TYPE.VENDOR_ONLY) && (
                                        <div style={{
                                            marginTop: "16px",
                                            background: "#fffde7",
                                            padding: "16px",
                                            borderRadius: "10px",
                                            border: "1px solid rgb(253 230 138)"
                                        }}>
                                            <h5>Vendor GST Registration</h5>
                                            <div style={{ display: "flex", gap: "10px", flexWrap: "wrap" }}>
                                                <label
                                                    style={{
                                                        display: "flex",
                                                        alignItems: "center",
                                                        border: this.state.gstType === VENDOR_GST_REGISTRATION_TYPE.GST_REGISTERED ? "2px solid #e9a217" : "1px solid #ddd",
                                                        padding: "10px 16px",
                                                        borderRadius: "8px",
                                                        cursor: "pointer",
                                                        background: this.state.gstType === VENDOR_GST_REGISTRATION_TYPE.GST_REGISTERED ? "#fef3cd" : "#fff",
                                                        fontWeight: this.state.gstType === VENDOR_GST_REGISTRATION_TYPE.GST_REGISTERED ? "600" : "normal"
                                                    }}
                                                >
                                                    <input
                                                        type="checkbox"
                                                        name="gstType"
                                                        value="gst_registered"
                                                        checked={this.state.gstType === VENDOR_GST_REGISTRATION_TYPE.GST_REGISTERED}
                                                        onChange={() => this.setState({ gstType: VENDOR_GST_REGISTRATION_TYPE.GST_REGISTERED })}
                                                        style={{ marginRight: "8px", accentColor: "#e9a217" }}
                                                    />
                                                    GST Registered
                                                </label>
                                                <label
                                                    style={{
                                                        display: "flex",
                                                        alignItems: "center",
                                                        border: this.state.gstType === VENDOR_GST_REGISTRATION_TYPE.NON_GST_VENDOR ? "2px solid #e9a217" : "1px solid #ddd",
                                                        padding: "10px 16px",
                                                        borderRadius: "8px",
                                                        cursor: "pointer",
                                                        background: this.state.gstType === VENDOR_GST_REGISTRATION_TYPE.NON_GST_VENDOR ? "#fef3cd" : "#fff",
                                                        fontWeight: this.state.gstType === VENDOR_GST_REGISTRATION_TYPE.NON_GST_VENDOR ? "600" : "normal"
                                                    }}
                                                >
                                                    <input
                                                        type="checkbox"
                                                        name="gstType"
                                                        value="non_gst"
                                                        checked={this.state.gstType === VENDOR_GST_REGISTRATION_TYPE.NON_GST_VENDOR}
                                                        onChange={() => this.setState({ gstType: VENDOR_GST_REGISTRATION_TYPE.NON_GST_VENDOR })}
                                                        style={{ marginRight: "8px", accentColor: "#e9a217" }}
                                                    />
                                                    Non-GST Vendor
                                                </label>
                                            </div>
                                        </div>
                                    )}


                                    <Row>
                                        <Col md={8}>
                                            {/* Top Row: Vendor & Send To */}
                                            <Row className="mb-3">
                                                <Col md={6}>
                                                    <Form.Group>
                                                        <Form.Label style={{ fontWeight: 600, fontSize: "13px", color: "#475569" }}>
                                                            {this.state.serviceType === SERVICE_PROVIDER_TYPE.VENDOR_WITH_AZURO_MARGIN
                                                                ? "Subcontractor Name"
                                                                : this.state.serviceType === SERVICE_PROVIDER_TYPE.VENDOR_ONLY
                                                                    ? "External Vendor Name"
                                                                    : "Vendor Name"}
                                                        </Form.Label>
                                                        <AsyncTypeahead
                                                            name="vendorId"
                                                            isLoading={this.state.isLoading}
                                                            options={this.state.options}
                                                            query={this.state.query}
                                                            id="estimate-modal-vendor-search"
                                                            labelKey="vendor"
                                                            maxResults={this.state.limit - 1}
                                                            minLength={3}
                                                            selected={values.vendorName ? [{ id: values.vendorId, vendor: values.vendorName }] : []}
                                                            onChange={(selected) => {
                                                                const vendorId = (selected.length > 0) ? selected[0].id : undefined;
                                                                const vendorName = (selected.length > 0) ? selected[0].vendor : "";
                                                                setFieldValue('vendorId', vendorId);
                                                                setFieldValue('vendorName', vendorName);
                                                            }}
                                                            onInputChange={this.handleInputChange}
                                                            onPaginate={this.handlePagination}
                                                            onSearch={this.handleSearch}
                                                            paginate
                                                            placeholder={"Search for vendor here..."}
                                                            renderMenuItemChildren={option => (
                                                                <div key={option.id}>
                                                                    <span>{option.vendor}</span>
                                                                </div>
                                                            )}
                                                            useCache={false}
                                                        />
                                                        <ErrorMessage name="vendorName" component="div" className="text-danger mt-1" style={{ fontSize: "12px" }} />
                                                    </Form.Group>
                                                </Col>
                                                <Col md={6}>
                                                    <Form.Group>
                                                        <Form.Label style={{ fontWeight: 600, fontSize: "13px", color: "#475569" }}>Send Estimate To</Form.Label>
                                                        <Form.Control as="select" name="sendEstimateTo" value={values.sendEstimateTo || ""} onChange={(e) => setFieldValue('sendEstimateTo', e.target.value)} style={{ borderRadius: "8px", border: "1px solid #cbd5e1", backgroundColor: "#fff", fontSize: "14px" }}>
                                                            <option value="">{constants.DEFAULT_OPTION}</option>
                                                            {
                                                                this.props.approverData && this.props.approverData.map((approverData) =>
                                                                    <option key={approverData.id} value={approverData.id}>
                                                                        {approverData.fullName}
                                                                        {approverData.userSubCategory && ' (' + formatProperCase(approverData.userSubCategory) + ')'}
                                                                    </option>
                                                                )
                                                            }
                                                        </Form.Control>
                                                    </Form.Group>
                                                </Col>
                                            </Row>

                                            {/* Customer Details Card */}
                                            <Card className="mb-4 shadow-sm border-0" style={{ borderRadius: "8px", border: "1px solid #e2e8f0 !important", boxShadow: "0 1px 2px rgba(0,0,0,0.05)" }}>
                                                <Card.Body className="p-3">
                                                    <h6 style={{ fontWeight: 700, marginBottom: "16px", color: "#1e293b", fontSize: "14px" }}>Customer Details</h6>
                                                    <Row>
                                                        <Col md={4}>
                                                            <Form.Group className="mb-0">
                                                                <Form.Label style={{ fontSize: "12px", color: "#64748b", marginBottom: "4px" }}>Customer Name</Form.Label>
                                                                <Field as={Form.Control} name="customerName" placeholder="Full name" style={{ background: "#f8fafc", border: "1px solid #e2e8f0", borderRadius: "6px", fontSize: "13px" }} />
                                                                <ErrorMessage name="customerName" component="div" className="text-danger mt-1" style={{ fontSize: "12px" }} />
                                                            </Form.Group>
                                                        </Col>
                                                        <Col md={5}>
                                                            <Form.Group className="mb-0">
                                                                <Form.Label style={{ fontSize: "12px", color: "#64748b", marginBottom: "4px" }}>Address</Form.Label>
                                                                <Field as={Form.Control} name="address" placeholder="Property address" style={{ background: "#f8fafc", border: "1px solid #e2e8f0", borderRadius: "6px", fontSize: "13px" }} />
                                                                <ErrorMessage name="address" component="div" className="text-danger mt-1" style={{ fontSize: "12px" }} />
                                                            </Form.Group>
                                                        </Col>
                                                        <Col md={3}>
                                                            <Form.Group className="mb-0">
                                                                <Form.Label style={{ fontSize: "12px", color: "#64748b", marginBottom: "4px" }}>GSTIN (If applicable)</Form.Label>
                                                                <Field as={Form.Control} name="gstin" placeholder="22AAAAA0000A1Z5" style={{ background: "#f8fafc", border: "1px solid #e2e8f0", borderRadius: "6px", fontSize: "13px" }} />
                                                                <ErrorMessage name="gstin" component="div" className="text-danger mt-1" style={{ fontSize: "12px" }} />
                                                            </Form.Group>
                                                        </Col>
                                                    </Row>
                                                </Card.Body>
                                            </Card>

                                            {/* Service Name */}
                                            <Row className="mb-4">
                                                <Col md={12}>
                                                    <Form.Group className="mb-0">
                                                        <Form.Label style={{ fontWeight: 600, fontSize: "13px", color: "#1e293b" }}>Service Name</Form.Label>
                                                        <Field as={Form.Control} name="serviceName" style={{ borderRadius: "8px", border: "1px solid #cbd5e1", backgroundColor: "#fff", fontSize: "14px" }} />
                                                        <ErrorMessage name="serviceName" component="div" className="text-danger mt-1" style={{ fontSize: "12px" }} />
                                                    </Form.Group>
                                                </Col>
                                            </Row>

                                            {/* Cost Details */}
                                            <div className="mb-4">
                                                <div className="d-flex justify-content-between align-items-center mb-3">
                                                    <h6 style={{ fontWeight: 700, margin: 0, color: "#1e293b", fontSize: "14px" }}>Cost Details</h6>
                                                    <Button type="button" variant="outline-primary" size="sm" style={{ borderRadius: "6px" }} onClick={() => this.addItem(values, setFieldValue)}>
                                                        + Add Item
                                                    </Button>
                                                </div>
                                                <Table hover responsive style={{ background: "#fff", borderRadius: "8px", overflow: "hidden", border: "1px solid #e2e8f0" }}>
                                                    <thead style={{ background: "#f8fafc" }}>
                                                        <tr>
                                                            <th style={{ fontSize: "12px", fontWeight: 600, color: "#64748b", borderBottom: "1px solid #e2e8f0", padding: "10px", width: "40px" }}>Sr. No.</th>
                                                            <th style={{ fontSize: "12px", fontWeight: 600, color: "#64748b", borderBottom: "1px solid #e2e8f0", padding: "10px" }}>Item Name</th>
                                                            <th style={{ fontSize: "12px", fontWeight: 600, color: "#64748b", borderBottom: "1px solid #e2e8f0", padding: "10px", width: "60px" }}>Qty</th>
                                                            <th style={{ fontSize: "12px", fontWeight: 600, color: "#64748b", borderBottom: "1px solid #e2e8f0", padding: "10px" }}>Base Cost (Vendor) ₹</th>
                                                            <th style={{ fontSize: "12px", fontWeight: 600, color: "#64748b", borderBottom: "1px solid #e2e8f0", padding: "10px" }}>Mark-Up (Azuro) ₹</th>
                                                            <th style={{ fontSize: "12px", fontWeight: 600, color: "#64748b", borderBottom: "1px solid #e2e8f0", padding: "10px" }}>GST %</th>
                                                            <th style={{ fontSize: "12px", fontWeight: 600, color: "#64748b", borderBottom: "1px solid #e2e8f0", padding: "10px" }}>Tax Amount ₹</th>
                                                            <th style={{ fontSize: "12px", fontWeight: 600, color: "#64748b", borderBottom: "1px solid #e2e8f0", padding: "10px" }}>Customer Total ₹</th>
                                                            <th style={{ fontSize: "12px", fontWeight: 600, color: "#64748b", borderBottom: "1px solid #e2e8f0", padding: "10px", width: "50px" }}></th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {values.items.map((item, index) => {
                                                            const row = this.calculateItemRow(item);
                                                            // For AZURO: base cost is 0 (display dash), markup drives everything
                                                            // For VENDOR_ONLY: markup is 0 (display dash)
                                                            const showBaseCost = true;
                                                            const showMarkup = this.state.serviceType !== SERVICE_PROVIDER_TYPE.VENDOR_ONLY;

                                                            return (
                                                                <tr key={index}>
                                                                    <td className="align-middle text-center" style={{ fontSize: "13px", color: "#64748b", fontWeight: 500, padding: "10px" }}>
                                                                        {index + 1}
                                                                    </td>
                                                                    <td className="align-middle" style={{ padding: "6px" }}>
                                                                        <Field as={Form.Control} name={`items.${index}.itemName`} placeholder="Item Name" size="sm" style={{ borderRadius: "6px" }} />
                                                                        <ErrorMessage name={`items.${index}.itemName`} component="div" className="text-danger mt-1 text-center" style={{ fontSize: "11px" }} />
                                                                    </td>
                                                                    <td className="align-middle" style={{ padding: "6px" }}>
                                                                        <Field as={Form.Control} type="number" name={`items.${index}.qty`} size="sm" style={{ borderRadius: "6px", width: "60px" }} placeholder="1" min="1" />
                                                                        <ErrorMessage name={`items.${index}.qty`} component="div" className="text-danger mt-1 text-center" style={{ fontSize: "11px" }} />
                                                                    </td>
                                                                    <td className="align-middle" style={{ padding: "6px" }}>
                                                                        {showBaseCost
                                                                            ? <><Field as={Form.Control} type="number" name={`items.${index}.amount`} size="sm" style={{ borderRadius: "6px" }} placeholder="0" min="0" /><ErrorMessage name={`items.${index}.amount`} component="div" className="text-danger mt-1 text-center" style={{ fontSize: "11px" }} /></>
                                                                            : <span style={{ color: "#94a3b8", padding: "0 8px" }}>—</span>
                                                                        }
                                                                    </td>
                                                                    <td className="align-middle" style={{ padding: "6px" }}>
                                                                        {showMarkup
                                                                            ? <><Field as={Form.Control} type="number" name={`items.${index}.margin`} size="sm" style={{ borderRadius: "6px" }} placeholder="0" min="0" /><ErrorMessage name={`items.${index}.margin`} component="div" className="text-danger mt-1 text-center" style={{ fontSize: "11px" }} /></>
                                                                            : <span style={{ color: "#94a3b8", padding: "0 8px" }}>—</span>
                                                                        }
                                                                    </td>
                                                                    <td className="align-middle" style={{ padding: "6px" }}>
                                                                        <Field
                                                                            as="select"
                                                                            name={`items.${index}.gstPercentage`}
                                                                            className="form-control form-control-sm"
                                                                            style={{ borderRadius: "6px", fontSize: "12px", padding: "4px 8px", width: "65px", display: "inline-block" }}
                                                                        >
                                                                            <option value="18">18%</option>
                                                                        </Field>
                                                                    </td>
                                                                    <td className="align-middle" style={{ padding: "10px" }}>
                                                                        <strong style={{ color: "#334155", fontSize: "13px" }}>
                                                                            {this.formatCurrency(row.taxAmount)}
                                                                        </strong>
                                                                    </td>
                                                                    <td className="align-middle" style={{ padding: "10px" }}>
                                                                        <strong style={{ color: "#1e40af", fontSize: "13px" }}>
                                                                            {this.formatCurrency(row.customerTotal)}
                                                                        </strong>
                                                                    </td>
                                                                    <td className="align-middle text-center" style={{ padding: "6px" }}>
                                                                        {index > 0 && (
                                                                            <Button
                                                                                type="button"
                                                                                size="sm"
                                                                                variant="outline-danger"
                                                                                style={{ borderRadius: "6px", padding: "3px 7px", fontSize: "11px" }}
                                                                                onClick={() => this.removeItem(index, values, setFieldValue)}
                                                                            >
                                                                                ✕
                                                                            </Button>
                                                                        )}
                                                                    </td>
                                                                </tr>
                                                            );
                                                        })}
                                                    </tbody>
                                                    <tfoot>
                                                        <tr style={{ background: "#f0f4ff" }}>
                                                            <td colSpan="3" style={{ fontSize: "13px", fontWeight: 700, color: "#475569", padding: "10px", borderTop: "2px solid #c7d7fe" }}>Total</td>
                                                            <td style={{ fontSize: "13px", fontWeight: 700, color: "#334155", padding: "10px", borderTop: "2px solid #c7d7fe" }}>
                                                                ₹ {this.formatCurrency(summary.vendorCost)}
                                                            </td>
                                                            <td style={{ fontSize: "13px", fontWeight: 700, color: "#334155", padding: "10px", borderTop: "2px solid #c7d7fe" }}>
                                                                {this.state.serviceType !== SERVICE_PROVIDER_TYPE.VENDOR_ONLY ? `₹ ${this.formatCurrency(summary.margin)}` : "—"}
                                                            </td>
                                                            <td style={{ padding: "10px", borderTop: "2px solid #c7d7fe" }}>—</td>
                                                            <td style={{ fontSize: "13px", fontWeight: 700, color: "#334155", padding: "10px", borderTop: "2px solid #c7d7fe" }}>
                                                                ₹ {this.formatCurrency(summary.gstInBill)}
                                                            </td>
                                                            <td style={{ fontSize: "14px", fontWeight: 700, color: "#1e293b", padding: "10px", borderTop: "2px solid #c7d7fe" }}>
                                                                ₹ {this.formatCurrency(summary.customerPays)}
                                                            </td>
                                                            <td style={{ borderTop: "2px solid #c7d7fe" }}></td>
                                                        </tr>
                                                    </tfoot>
                                                </Table>

                                                {/* Inline Real-time Summary Ribbon */}
                                                {(summary.customerPays > 0) && (
                                                    <div className="mt-3 d-flex mb-3" style={{ gap: "8px", flexWrap: "wrap" }}>
                                                        <div style={{ flex: 1, minWidth: "120px", background: "#eff6ff", borderRadius: "8px", padding: "10px 14px", border: "1px solid #bfdbfe" }}>
                                                            <div style={{ fontSize: "10px", color: "#3b82f6", fontWeight: 700, letterSpacing: "0.4px", marginBottom: "2px" }}>CUSTOMER TOTAL</div>
                                                            <div style={{ fontSize: "15px", fontWeight: 700, color: "#1e40af" }}>₹ {this.formatCurrency(summary.customerPays)}</div>
                                                        </div>
                                                        <div style={{ flex: 1, minWidth: "110px", background: "#fafafa", borderRadius: "8px", padding: "10px 14px", border: "1px solid #e2e8f0" }}>
                                                            <div style={{ fontSize: "10px", color: "#64748b", fontWeight: 700, letterSpacing: "0.4px", marginBottom: "2px" }}>GST IN BILL</div>
                                                            <div style={{ fontSize: "15px", fontWeight: 700, color: "#334155" }}>₹ {this.formatCurrency(summary.gstInBill)}</div>
                                                        </div>
                                                        <div style={{ flex: 1, minWidth: "110px", background: "#f0fdf4", borderRadius: "8px", padding: "10px 14px", border: "1px solid #bbf7d0" }}>
                                                            <div style={{ fontSize: "10px", color: "#16a34a", fontWeight: 700, letterSpacing: "0.4px", marginBottom: "2px" }}>INPUT GST CREDIT</div>
                                                            <div style={{ fontSize: "15px", fontWeight: 700, color: "#15803d" }}>₹ {this.formatCurrency(summary.inputGstCredit)}</div>
                                                        </div>
                                                        <div style={{ flex: 1, minWidth: "110px", background: "#fff7ed", borderRadius: "8px", padding: "10px 14px", border: "1px solid #fed7aa" }}>
                                                            <div style={{ fontSize: "10px", color: "#ea580c", fontWeight: 700, letterSpacing: "0.4px", marginBottom: "2px" }}>NET GST TO GOVT</div>
                                                            <div style={{ fontSize: "15px", fontWeight: 700, color: "#c2410c" }}>₹ {this.formatCurrency(summary.netGst)}</div>
                                                        </div>
                                                    </div>
                                                )}
                                            </div>

                                            {/* Payment Schedule */}
                                            <div className="mb-4">
                                                <h6 style={{ fontWeight: 700, marginBottom: "16px", color: "#1e293b", fontSize: "14px" }}>Payment Schedule</h6>
                                                <Row>
                                                    <Col md={5}>
                                                        <div
                                                            className="p-3"
                                                            style={{
                                                                border: values.paymentType === PAYMENT_TYPES.FULL_PAYMENT ? "2px solid #3b82f6" : "1px solid #cbd5e1",
                                                                borderRadius: "8px",
                                                                background: values.paymentType === PAYMENT_TYPES.FULL_PAYMENT ? "#eff6ff" : "#fff",
                                                                cursor: "pointer",
                                                                transition: "all 0.2s"
                                                            }}
                                                            onClick={() => setFieldValue("paymentType", PAYMENT_TYPES.FULL_PAYMENT)}
                                                        >
                                                            <div className="d-flex align-items-center mb-1">
                                                                <div style={{
                                                                    width: "16px", height: "16px", borderRadius: "50%",
                                                                    border: values.paymentType === PAYMENT_TYPES.FULL_PAYMENT ? "5px solid #2563eb" : "1px solid #cbd5e1",
                                                                    background: "#fff",
                                                                    marginRight: "10px"
                                                                }}></div>
                                                                <strong style={{ color: values.paymentType === PAYMENT_TYPES.FULL_PAYMENT ? "#1e3a8a" : "#334155", fontSize: "13px", fontWeight: 600 }}>Full Payment</strong>
                                                            </div>
                                                            <div style={{ fontSize: "11px", color: "#64748b", marginLeft: "26px" }}>Customer pays full amount</div>
                                                        </div>
                                                    </Col>
                                                    <Col md={5}>
                                                        <div
                                                            className="p-3"
                                                            style={{
                                                                border: values.paymentType === PAYMENT_TYPES.ADVANCE_PAYMENT ? "2px solid #3b82f6" : "1px solid #cbd5e1",
                                                                borderRadius: "8px",
                                                                background: values.paymentType === PAYMENT_TYPES.ADVANCE_PAYMENT ? "#eff6ff" : "#fff",
                                                                cursor: "pointer",
                                                                transition: "all 0.2s"
                                                            }}
                                                            onClick={() => setFieldValue("paymentType", PAYMENT_TYPES.ADVANCE_PAYMENT)}
                                                        >
                                                            <div className="d-flex align-items-center mb-1">
                                                                <div style={{
                                                                    width: "16px", height: "16px", borderRadius: "50%",
                                                                    border: values.paymentType === PAYMENT_TYPES.ADVANCE_PAYMENT ? "5px solid #2563eb" : "1px solid #cbd5e1",
                                                                    background: "#fff",
                                                                    marginRight: "10px"
                                                                }}></div>
                                                                <strong style={{ color: values.paymentType === PAYMENT_TYPES.ADVANCE_PAYMENT ? "#1e3a8a" : "#334155", fontSize: "13px", fontWeight: 600 }}>Advance Payment</strong>
                                                            </div>
                                                            <div style={{ fontSize: "11px", color: "#64748b", marginLeft: "26px" }}>Customer pays in advance</div>
                                                        </div>
                                                    </Col>
                                                </Row>

                                                {/* Advance Amount Sub-field */}
                                                {values.paymentType === PAYMENT_TYPES.ADVANCE_PAYMENT && (
                                                    <Row className="mt-3">
                                                        <Col md={5}>
                                                            <Form.Group className="mb-0">
                                                                <Form.Label style={{ fontSize: "13px", fontWeight: 600, color: "#334155" }}>Advance Amount</Form.Label>
                                                                <div className="position-relative">
                                                                    <span className="position-absolute" style={{ left: "14px", top: "10px", color: "#94a3b8", fontSize: "14px" }}>₹</span>
                                                                    <Field as={Form.Control} type="number" name="advanceAmount" placeholder="0" min="0" style={{ paddingLeft: "30px", borderRadius: "8px", border: "1px solid #cbd5e1", backgroundColor: "#fff", fontSize: "14px" }} />
                                                                </div>
                                                                <ErrorMessage name="advanceAmount" component="div" className="text-danger mt-1" style={{ fontSize: "12px" }} />
                                                            </Form.Group>
                                                        </Col>
                                                    </Row>
                                                )}
                                            </div>
                                        </Col>

                                        {/* RIGHT PANEL - FINANCIAL DASHBOARD */}
                                        <Col md={4}>
                                            {this.renderSummaryPanel(summary, paymentSummary, values)}
                                        </Col>
                                    </Row>
                                </Modal.Body>

                                <Modal.Footer className="bg-white border-top-0 pt-0 pb-4 px-4 d-flex justify-content-between" style={{ background: "#f8fafc" }}>
                                    <Button variant="outline-secondary" onClick={onHide} style={{ borderRadius: "8px", fontWeight: 600, padding: "8px 20px", border: "1px solid #cbd5e1", color: "#475569", background: "#fff" }}>
                                        <i className="fa fa-times mr-2" style={{ fontSize: "13px" }}></i> Cancel
                                    </Button>
                                    <Button variant="primary" onClick={handleSubmit} disabled={isSubmitting} style={{ borderRadius: "8px", fontWeight: 600, padding: "8px 24px", background: "#2563eb", border: "none", color: "#fff", boxShadow: "0 2px 6px rgba(37,99,235,0.25)" }}>
                                        <i className="far fa-paper-plane mr-2" style={{ fontSize: "13px" }}></i> {isSubmitting ? "Sending..." : "Send Estimate"}
                                    </Button>
                                </Modal.Footer>

                            </React.Fragment>
                        );
                    }
                    }

                </Formik >
            </Modal >

        );
    }
}

export default EstimateModal;
